// src/components/lesson/IntroTemplate.jsx

import React from "react";

import LessonShell from "./LessonShell";
import LessonMedia from "./LessonMedia";

const TEMP_INTRO_IMAGE =
  "https://placehold.co/900x900/F1F1F1/111111?text=Replace+Introduction+Media";

export default function IntroTemplate({
  /*
   * Existing production props
   */
  paragraphs = [],

  imageSrc = "",
  imageAlt =
    "Lesson introduction",

  nextTo,
  nextLabel = "Next",
  onNext,

  backTo,
  backLabel = "Back",
  onBack,

  progressStep = 2,
  progressTotal = 11,

  /*
   * Optional media
   */
  videoSrc = "",
  videoPoster = "",

  animationSrc = "",

  mediaType = "",

  mediaLabel =
    "Lesson introduction",

  /*
   * Compatibility
   */
  levelName = "",
  title = "",
}) {
  const resolvedMediaType =
    mediaType ||
    (videoSrc
      ? "video"
      : animationSrc
      ? "animation"
      : "image");

  const suppliedMediaSrc =
    resolvedMediaType ===
    "video"
      ? videoSrc
      : resolvedMediaType ===
        "animation"
      ? animationSrc
      : imageSrc;

  /*
   * Canva placeholder until you add
   * the final Supabase URL.
   */
  const resolvedMediaSrc =
    suppliedMediaSrc ||
    TEMP_INTRO_IMAGE;

  return (
    <LessonShell
      progressStep={
        progressStep
      }
      progressTotal={
        progressTotal
      }

      showBack
      backLabel={
        backLabel
      }
      backTo={
        backTo
      }
      onBack={
        onBack
      }

      showNext
      nextLabel={
        nextLabel
      }
      nextTo={
        nextTo
      }
      onNext={
        onNext
      }

      contentClassName="
        pt-8
      "
    >
      {/*
       * INTRODUCTION HEADING
       */}
      <p
        className="
          text-center
          text-[18px]
          font-extrabold
          uppercase
          text-[#FF914D]
        "
      >
        Introduction
      </p>

      {/*
       * MAIN INTRO MEDIA
       *
       * Matches the large rounded media
       * panel in Canva.
       */}
      <div
        className="
          mx-auto
          mt-14
          w-full
          max-w-[560px]
        "
      >
        <div
          className="
            overflow-hidden
            rounded-[28px]
            bg-[#F1F1F1]
          "
        >
          <LessonMedia
            type={
              resolvedMediaType
            }
            src={
              resolvedMediaSrc
            }
            poster={
              videoPoster
            }
            alt={
              imageAlt
            }
            label={
              mediaLabel
            }

            controls={
              resolvedMediaType ===
              "video"
            }

            autoPlay={
              resolvedMediaType ===
              "animation"
            }

            loop={
              resolvedMediaType ===
              "animation"
            }

            muted={
              resolvedMediaType ===
              "animation"
            }
          />
        </div>
      </div>

      {/*
       * Paragraphs are intentionally
       * not rendered in the final visual
       * layout because the Canva Intro
       * puts that information inside the
       * media/animation itself.
       *
       * Prop stays for compatibility.
       */}
      {false &&
        paragraphs.map(
          (
            paragraph,
            index
          ) => (
            <p key={index}>
              {paragraph}
            </p>
          )
        )}
    </LessonShell>
  );
}